export default __webpack_public_path__ + "land-use-500-4722a3a6198dddaf7dc035c77616ad36.webp";